import {
  JOB_TIME_ENTRY_REPORT_REQUEST,
  JOB_TIME_ENTRY_REPORT_SUCCESS,
  JOB_TIME_ENTRY_REPORT_FAIL,
} from "./actionType";

export const getJobTimeEntryReport = (data) => ({
  type: JOB_TIME_ENTRY_REPORT_REQUEST,
  payload: data,
});

export const getJobTimeEntryReportSuccess = (data) => ({
  type: JOB_TIME_ENTRY_REPORT_SUCCESS,
  payload: data,
});

export const getJobTimeEntryReportFail = (error) => ({
  type: JOB_TIME_ENTRY_REPORT_FAIL,
  payload: error,
});
